import axios from 'src/utils/axios';
import { API_PATH } from 'src/config-global';

// ----------------------------------------------------------------------

export const topGameDisplay = async (payload: any) => {
  const URL = API_PATH.GAME_GET_TOP_LIST;
  const response = await axios.post(URL, payload);
  return response.data;
};

export const topCategoryGameDisplay = async (payload: any) => {
  const URL = API_PATH.GAME_GET_TOP_CATEGORY_LIST;
  const response = await axios.post(URL, payload);
  return response.data;
};

export const gameDisplay = async (payload: any) => {
  const URL = API_PATH.GAME_GET_LIST;
  const response = await axios.post(URL, payload);
  return response.data;
};

export const gameLaunch = async (payload: any) => {
  const URL = API_PATH.GAME_ACCESS_URL;
  const response = await axios.post(URL, payload);
  return response?.data || { data: false };
};

export const getProviderList = async (payload: any) => {
  const URL = API_PATH.PROVIDER_GET_LIST;
  const response = await axios.post(URL, payload);
  return response.data;
};

export const getWinDataList = async () => {
  const URL = API_PATH.WIN_DATA_GET;
  const response = await axios.post(URL);
  return response.data;
};

export const getCategories = async () => {
  const URL = API_PATH.CATEGORIES_GET;
  const response = await axios.post(URL);
  return response.data;
};
